import Brush from "../assets/Brush_Cartoon.svg";
import Pen from "../assets/Pen_Cartoon.svg";
import Pencil from "../assets/Pencil_Cartoon.svg";
import Highlighter from "../assets/Highlighter_Cartoon.svg";
import Eraser from "../assets/Eraser_Cartoon.svg";
import Text from "../assets/Text_Cartoon.svg";

export const ToolsData = [
    {
        name: "Brush",
        image: Brush,
        colors: [
            "#e98427",
            "#438342",
            "#6f219e",
            "#e9bb18",
            "#59371d",
            "#1c1a1a",
            "#fff2e5",
        ],
        fontSize: 12,
    },
    {
        name: "Highlighter",
        image: Highlighter,
        colors: [
            "#faae66",
            "#8ff58e",
            "#cd8af7",
            "#fff27f",
            "#f0cbaf",
            "#8ce3e9",
            "#ffe7d0",
        ],
        fontSize: 8,
    },
    {
        name: "Pen",
        image: Pen,
        colors: [
            "#e98427",
            "#438342",
            "#6f219e",
            "#e9bb18",
            "#59371d",
            "#1c1a1a",
            "#fff2e5",
        ],
        fontSize: 5,
    },
    {
        name: "Pencil",
        image: Pencil,
        colors: [
            "#e98427",
            "#438342",
            "#6f219e",
            "#e9bb18",
            "#59371d",
            "#1c1a1a",
            "#fff2e5",
        ],
        fontSize: 2,
    },
    {
        name: "Eraser",
        image: Eraser,
        colors: [
            "#e98427",
            "#438342",
            "#6f219e",
            "#e9bb18",
            "#59371d",
            "#1c1a1a",
            "#fff2e5",
        ],
        fontSize: 12,
    },
    {
        name: "Text",
        image: Text,
        colors: [
            "#e98427",
            "#438342",
            "#6f219e",
            "#e9bb18",
            "#59371d",
            "#1c1a1a",
            "#fff2e5",
        ],
        fontSize: 0,
    },
];
